module.exports = __webpack_public_path__ + "img/bgc14.5a68cac4.png";